import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { WebsiteUiService } from '../../website-ui.service';
import { AVAANA_LINKS, HOW_IT_WORKS_LINKS, WHO_ITS_FOR_LINKS } from '../../website.data';
import { NavLink } from '../../website.models';

interface FooterColumn {
  title: string;
  links: NavLink[];
}

@Component({
  selector: 'app-web-footer',
  imports: [RouterLink],
  templateUrl: './web-footer.html',
  styleUrls: ['./web-footer.scss']
})
export class WebFooterComponent {
  currentYear = new Date().getFullYear();

  columns: FooterColumn[] = [
    { title: 'How it works', links: HOW_IT_WORKS_LINKS },
    { title: "Who it's for", links: WHO_ITS_FOR_LINKS },
    { title: 'Avaana', links: AVAANA_LINKS }
  ];

  legalLinks: NavLink[] = [
    { label: 'Privacy Policy', link: '/privacy-policy' },
    { label: 'Collection Statements', link: '/collection-statements' },
    { label: 'Disclaimer', link: '/disclaimer' },
    { label: 'Terms and Agreements', link: '/booking-terms' }
  ];

  constructor(private ui: WebsiteUiService) {}

  openLogin(event: Event): void {
    // Stop the click reaching the nav's outside-click handler, which would close the panel again
    event.stopPropagation();
    this.ui.openLogin$.next();
  }
}
